import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import ChannelItem from "@/components/ChannelItem.vue";
import Loading from '@/components/Loading.vue';
import { Channels } from '@/models/channels';
import { Plans } from '@/models/plans';
import { Channel } from '@/models/channel';

@Component({
	components: {
		ChannelItem,
		Loading
	}
})
export default class AdminChannelsHome extends Vue {
	@Prop() public channels!: Channels;
	@Prop() public plans!: Plans;
	@Prop() public isLoadingChannels!: boolean;
	@Prop() public groupName!: string;
	private subTitle: string = "カリキュラム一覧";
	// イベント名はケバブケース
	@Emit("click-channel-item")
	public clickChannelItem(channelId: string) { }


	public async created(): Promise<void> {
		// このメソッド内でアクセストークンを使用する場合は以下のコードを有効化する。
		// アクセストークンが有効でない場合はルートに遷移。
		// if (!await GraphApiUtils.isValidAccessToken(Vue.$accessToken)) {
		// 	this.$router.push(Consts.PATH_ADMIN);
		// 	return;
		// }
	}

	public onChannelItemClick(channelId: string): void {
		this.clickChannelItem(channelId);
	}

	private getPlanId(channelId: string): string {
		if (this.channels === undefined) {
			return '';
		}
		const channel: Channel | null = this.channels.get(channelId);
		if (channel === null) {
			return '';
		}
		const plan = this.plans.getByTitle(channel.displayName);
		if (plan === null) {
			return '';
		}
		return plan.id;
	}

	private disabled(channelId: string): boolean {
		return false;
	}


}
